// components/SettingsPage

import React, { useState } from 'react';
import LogoGallery from '../Settings/LogoGallery';
import LogoModal from '../Settings/LogoModal';
import CategoryManagement from '../Requirements/CategoryManagement';
import ManagePaysSection from '../Settings/ManagePaysSection';
import ManageBankAccountsSection from '../Settings/ManageBankAccountsSection';
import UserProfile from '../Settings/UserProfile';
import { Card, Nav, Alert } from 'react-bootstrap';
import '../../css/Settings.css';

const SettingsPage = () => {
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [activeTab, setActiveTab] = useState('#profile');
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const logoOptions = [
    'budgit_logo.png',
    'budgit_logo2.png',
    'budgit_logo3.png',
    'budgit_logo4.png',
    'budgit_logo5.png',
    'budgit_logo6.png',
    'budgit_logo7.png',
    'budgit_logo8.png',
    'budgit_logo9.png',
    'budgit_logo10.png',
    'budgit_logo11.png',
    'budgit_logo12.png',
    'budgit_logo13.png',
    'budgit_logo14.png',
    'budgit_logo15.png',
    'budgit_logo16.png',
    'budgit_logo17.png',
    'budgit_logo18.png',
    'budgit_logo19.png',
    'budgit_logo20.png',
    'budgit_logo21.png',
    'budgit_logo22.png',
    'budgit_logo23.png',
    'budgit_logo24.png',
    'budgit_logo25.png'
  ].map(filename => `${window.location.protocol}//${window.location.host}/static/logos/${filename}`);

  const handleLogoSelection = (logo) => {
    setSelectedLogo(logo);
  };

  const handlePrevLogo = () => {
    const currentIndex = logoOptions.indexOf(selectedLogo);
    const prevIndex = (currentIndex - 1 + logoOptions.length) % logoOptions.length;
    setSelectedLogo(logoOptions[prevIndex]);
  };

  const handleNextLogo = () => {
    const currentIndex = logoOptions.indexOf(selectedLogo);
    const nextIndex = (currentIndex + 1) % logoOptions.length;
    setSelectedLogo(logoOptions[nextIndex]);
  };

  const handleCloseModal = () => {
    setSelectedLogo(null);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setShowSuccess(false);
  };

  const handleFormSuccess = (message) => {
    setSuccessMessage(message);
    setShowSuccess(true);
  };

  return (
    <div className="page-content settings-page">
      <Card>
        <Card.Header>
          <Nav variant="tabs" activeKey={activeTab} onSelect={handleTabChange}>
            <Nav.Item>
              <Nav.Link eventKey="#profile">Profile</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="#logo">Logo</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="#manage-pays">Manage pays</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="#manage-bank-accounts">Manage bank accounts</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="#categories">Categories</Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>
        <Card.Body>
          {activeTab === '#profile' && (
            <UserProfile />
          )}

          {activeTab === '#logo' && (
            <>
              <h3 className="page-title">Logo</h3>
              <div style={{ marginLeft: '40px' }}>
                <p>Choose your budgit logo.</p>
              </div>
              <LogoGallery
                logoOptions={logoOptions}
                selectedLogo={selectedLogo}
                onSelectLogo={handleLogoSelection}
              />
              {selectedLogo && (
                <LogoModal
                  logoOptions={logoOptions}
                  selectedLogo={selectedLogo}
                  onClose={handleCloseModal}
                  onPrev={handlePrevLogo}
                  onNext={handleNextLogo}
                />
              )}
            </>
          )}

          {activeTab === '#manage-pays' && (
            <>
              {showSuccess && (
                <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                  {successMessage}
                </Alert>
              )}
              <ManagePaysSection onNotify={handleFormSuccess} />
            </>
          )}

          {activeTab === '#manage-bank-accounts' && (
            <>
              {showSuccess && (
                <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                  {successMessage}
                </Alert>
              )}
              <ManageBankAccountsSection onNotify={handleFormSuccess} />
            </>
          )}

          {activeTab === '#categories' && (
            <CategoryManagement />
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default SettingsPage;
